import { copyToClipboard } from '@scripts/client/utils/utilities.js';

const SELECTORS = {
    block: '.wp-block-ssm-share-info',
    copyLink: '.js-copy-link',
};

export const ShareInfo = () => {
    document.querySelectorAll(SELECTORS.block).forEach((block) => {
        initShareInfo(block);
    });
};

export const initShareInfo = (block) => {
    const copyLink = block.querySelector(SELECTORS.copyLink);

    copyLink?.addEventListener('click', (e) => {
        e.preventDefault();

        copyToClipboard(copyLink.getAttribute('href'));

        if (!copyLink.querySelector('.success')) {
            const div = document.createElement('div');
            div.className = 'success absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-black text-white p-1 text-xs whitespace-nowrap';
            div.textContent = 'Copied!';
            copyLink.appendChild(div);

            setTimeout(() => {
                div.remove();
            }, 3000);
        }
    });
};
